if (!customElements.get('logos-marquee')) {
  class LogosMarquee extends HTMLElement {
    autoplayInterval = null;

    constructor() {
      super();
    }

    connectedCallback() {
      if (this.querySelector('.logo-bar--marquee')) {
        this.initMarquee();
      } else {
        this.autoplayLogos();
      }
    }

    initMarquee() {
      this.querySelectorAll('[data-slide-index]').forEach((logo) => {
        logo.addEventListener('click', () => this.setActiveLogo(logo))
      });
    }

    setActiveLogo(logo) {
      const titles = this.querySelectorAll('[data-title-index]');
      for (const title of titles) {
        title.classList.toggle(
          'active',
          Number(title.getAttribute('data-title-index')) === Number(logo.getAttribute('data-slide-index'))
        );
      }

      for (const item of logo.parentElement.children) {
        item.classList.toggle('active', item === logo);
      }
    }

    nextLogo() {
      const activeLogo = this.querySelector('.logo-bar .active');
      const nextLogo = activeLogo.nextElementSibling || activeLogo.parentElement.firstElementChild;
      this.setActiveLogo(nextLogo);
    }

    autoplayLogos() {
      this.autoplayInterval = setInterval(() => {
        this.nextLogo();
      }, 3000);
    }
  }
  customElements.define('logos-marquee', LogosMarquee);
}
